export default __webpack_public_path__ + "static/media/ojo-logo-footer.ccffc579.svg";